<template>
    <slide-x-left-transition :duration="index < 5 ? 400+(index*100) : 400" :delay="index < 5 ? 200+(index*100) : 200">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
            <ion-item>
                <ion-thumbnail slot="end" style="width: 65px; height: 60px; padding: 15px 0; text-align:center">
                    <svg class="icon"><use :xlink:href="'#'+icon"></use></svg>
                    <p class="ion-text-wrap" style="margin: 6px 0;font-size: 8px; text-transform: uppercase; text-align: center">{{ category_name }}</p>
                </ion-thumbnail>
                <ion-label mode="md" class="ion-text-wrap">
                    <h3 style="text-transform: uppercase">{{ title }}</h3>
                    <p v-html="excerpt"></p>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-button mode="ios" fill="outline" size="small" @click="openModal(title, description)">Czytaj więcej</ion-button>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import Modal from '@/components/Modal.vue';

    export default {
        name: 'ItemWiki',
        props: ['index', 'slug', 'icon', 'category_name', 'title', 'excerpt', 'description'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            openModal(title, description){
                return this.$ionic.modalController.create({
                    component: Modal,
                    mode: 'ios',
                    componentProps: {
                        propsData: {
                            title: title,
                            html: description
                        },
                    },
                }).then(m => m.present())
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 6px 15px;
    }
    .icon{
        width: 40px;
        height: 40px;
        fill: #c09a53;
    }
</style>